import { EnvironmentOutlined } from '@ant-design/icons';
import { Card, Select, Space } from 'antd';
import type { GetRegionsQuery } from 'gql/types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

interface IProps {
  value: string;
  onChange: (value: string) => void;
  regionsData: GetRegionsQuery | undefined;
}

const RegionFilter: React.FC<IProps> = ({ value, onChange, regionsData }) => {
  const { t } = useTranslation('dashboard.DonorDashboard.RegionFilter');

  return (
    <Card>
      <Space align="center" size="large">
        <EnvironmentOutlined style={{ fontSize: '16px', color: '#1890ff' }} />
        <span style={{ fontWeight: 'bold', marginRight: '8px' }}>
          {t('region')}
        </span>
        <Select
          value={value}
          onChange={onChange}
          style={{ minWidth: '150px' }}
          placeholder={t('selectRegion')}
        >
          <Option value="all">{t('allRegions')}</Option>
          {regionsData?.getRegions?.map((region) => (
            <Option key={region.id} value={region.id}>
              {region.name}
            </Option>
          ))}
        </Select>
      </Space>
    </Card>
  );
};

export default RegionFilter;
